import React from 'react';

function UserPresence({ onlineUsers, currentUser }) {
  const otherUsers = onlineUsers.filter(user => user.user_id !== currentUser?.id);

  if (otherUsers.length === 0) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: '70px',
      right: '20px',
      background: 'white',
      borderRadius: '8px',
      padding: '12px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      border: '1px solid #e0e0e0',
      zIndex: 100,
      minWidth: '200px'
    }}>
      <div style={{ 
        fontSize: '12px', 
        fontWeight: 'bold', 
        color: '#666', 
        marginBottom: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
      }}>
        <div style={{
          width: '8px',
          height: '8px',
          backgroundColor: '#28a745',
          borderRadius: '50%',
          animation: 'pulse 2s infinite'
        }} />
        Online ({otherUsers.length})
      </div>
      
      {otherUsers.map(user => (
        <div key={user.user_id} style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '4px 0',
          fontSize: '14px'
        }}>
          <div style={{
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            backgroundColor: getUserColor(user.user_email),
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            fontWeight: 'bold'
          }}>
            {getUserInitials(user.user_name || user.user_email)}
          </div>
          
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: '500' }}>
              {user.user_name || user.user_email}
            </div>
            {user.current_board && (
              <div style={{ fontSize: '12px', color: '#666' }}>
                Viewing: {user.current_board}
              </div>
            )}
          </div>
          
          <div style={{
            fontSize: '11px',
            color: '#999'
          }}>
            {getTimeAgo(user.last_seen)}
          </div>
        </div>
      ))}
      
      <style jsx>{`
        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.5; }
          100% { opacity: 1; }
        }
      `}</style>
    </div>
  );
}

// Helper functions
function getUserColor(email) {
  const colors = ['#007bff', '#28a745', '#dc3545', '#ffc107', '#17a2b8', '#6f42c1'];
  const hash = email.split('').reduce((a, b) => {
    a = ((a << 5) - a) + b.charCodeAt(0);
    return a & a;
  }, 0);
  return colors[Math.abs(hash) % colors.length];
}

function getUserInitials(name) {
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
}

function getTimeAgo(timestamp) {
  const diff = Date.now() - new Date(timestamp).getTime();
  const minutes = Math.floor(diff / 60000);
  
  if (minutes < 1) return 'now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}

export default UserPresence;
